// import React from 'react'
// import './services.css'
// import ServiceCard from '../../components/ServicesCard'
// import data from './data'
// const Services = () => {
 
//   return (
//    <section id="services">
//     <h1 className="port-head" style={{textAlign:"center",
//       fontSize:"1.9rem",
//       fontWeight:"800",
//       color:"rgb(0,0,0)",
//       margin:"2rem 0"}}>EDUCATION & EXPERIENCE</h1>
  
//    <div className='container service__container'>
//    <div className='left-service'>
//    {
//   data.map(item=>(
// item.id<=3?(
//     <ServiceCard key={item.id}
//      className='service__card' 
// >
//       <h5>{item.title}</h5>
//       <small>{item.desc}</small>
//     </ServiceCard> 
//   ):
//   <></>
//   ))
// } 
//    </div>
//   <div className='right-service'>
//   {
//   data.map(item=>(
// item.id>3?(
//     <ServiceCard key={item.id} className='service__card'>
//       <h5>{item.title}</h5>
//       <small>{item.desc}</small>
//     </ServiceCard> 
//   ):
//   <></>
//   ))
// } 
//    </div>

//    </div>
//    </section>
//   )
// }

// export default Services
// Services.jsx
import React from 'react';
import { FaAward } from 'react-icons/fa';
import { TbBooks } from 'react-icons/tb';
import { BiHappyHeartEyes } from 'react-icons/bi';

const data = [
  { id: 1, title: 'Software Engineering', desc: 'MUET - Jamshoro' },
  { id: 2, title: 'Intermediate', desc: 'Hayat Girls College' },
  { id: 3, title: 'Web Development Internship', desc: 'Sayabidevs Internship' },
  { id: 4, title: 'MERN stack developer ', desc: 'Tiers Limited' },
  { id: 5, title: 'Frontend Web Developer', desc: 'SES MUET' },
  { id: 6, title: 'Frontend Web Developer', desc: 'Tiers Limited' },
];

const Services = () => {
  return (
    <div className="container my-5">
      <h2  className='sec-title'>Education & Experience</h2>
      <div className="row">
        {data.map((item, index) => (
          <div key={item.id} className="col-md-4 mb-4">
            <div className="card " style={styles.card}>
              <div className="card-body text-center ">
                <div className="icon mb-3" style={styles.icon}>
                  {index % 3 === 0 ? (
                    <FaAward size={40} />
                  ) : index % 3 === 1 ? (
                    <TbBooks size={40} />
                  ) : (
                    <BiHappyHeartEyes size={40} />
                  )}
                </div>
                <h5 className="card-title" style={styles.title}>{item.title}</h5>
                <p className="card-text" style={styles.text}>{item.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  card: {
    border: 'none',
    transition: 'transform 0.2s',
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
  },
  cardHover: {
    transform: 'scale(1.05)',
  },
  icon: {
    color: 'var(--secondary)', // Bootstrap primary color
  },
  title: {
    fontWeight: 'bold',
  },
  text: {
    color: '#555',
  },
};

export default Services;
